import _ from 'lodash';

import {
  SET_CONTACT_FORM_FIELD,
  SEND_CONTACT_FORM,
  RESET_CONTACT_FORM,
  HANDLE_CONTACT_FORM_SUCCESS,
  HANDLE_CONTACT_FORM_FAILURE,
  SHOW_CONTACT_FORM_NOTIFICATION,
  HIDE_CONTACT_FORM_NOTIFICATION,
} from '../actionTypes';
import {
  ContactFormAction,
  ContactFormState,
} from 'datasetLandingPage/components/ContactForm/types/contactForm';

const currentUserEmail = _.get(window, 'sessionData.email', '');

export const initialState: ContactFormState = {
  fields: {
    email: {
      value: currentUserEmail,
      invalid: _.isEmpty(currentUserEmail),
    },
    subject: {
      value: '',
      invalid: true,
    },
    message: {
      value: '',
      invalid: true,
    },
  },
  status: '',
  previousStatus: '',
  notificationVisible: false,
};

export default function (state: ContactFormState, action: ContactFormAction) {
  if (_.isUndefined(state)) {
    return initialState;
  }

  switch (action.type) {
    case SET_CONTACT_FORM_FIELD:
      return {
        ...state,
        fields: {
          ...state.fields,
          [action.field]: action.value,
        },
      };

    case SHOW_CONTACT_FORM_NOTIFICATION:
      return {
        ...state,
        notificationVisible: true,
      };

    case HIDE_CONTACT_FORM_NOTIFICATION:
      return {
        ...state,
        notificationVisible: false,
      };

    case SEND_CONTACT_FORM:
      return {
        ...state,
        status: 'sending',
        previousStatus: 'sending',
      };

    case RESET_CONTACT_FORM:
      return {
        ...initialState,
        previousStatus: state.previousStatus,
        notificationVisible: state.notificationVisible,
      };

    case HANDLE_CONTACT_FORM_SUCCESS:
      return {
        ...state,
        status: 'success',
        previousStatus: 'success',
        notificationVisible: true,
      };

    case HANDLE_CONTACT_FORM_FAILURE:
      return {
        ...state,
        status: 'failure',
        previousStatus: 'failure',
        notificationVisible: true,
      };

    default:
      return state;
  }
}
